// ** React Imports
import { useSelector } from 'react-redux';

// ** CoreUI Imports
import CIcon from '@coreui/icons-react';
import { cilLightbulb } from '@coreui/icons'
import { CBadge, CLink } from '@coreui/react';

// ** Components Imports
import { HoverInfoIconTooltip } from '../../../../general/custom-tooltips';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from '../../../../general/dropdown';

// ** Constants Imports
import { SAVED_VIEW_TYPE } from '../../../../../constants/reportView';
import PropTypes from 'prop-types';

const ViewReportCard = ({ viewReport, index, handleConfirm, handleSchedule, handleAiTemplate }) => {
     const user = useSelector((state) => state.theme.user);
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const intelligenceSetting = useSelector((state) => state.subscriber.intelligenceSetting);
     const itemDropdown = [
          {
               title: 'Delete',
               confirmTitle: 'Delete this Report',
               confirmDescription: 'You are about to delete this Report. Please confirm.',
               type: SAVED_VIEW_TYPE.DELETE,
               show: false,
          },
          {
               title: 'Settings',
               type: SAVED_VIEW_TYPE.SETTING,
               show: true,
          },
          {
               title: 'Share URL',
               confirmTitle: 'Share URL',
               confirmDescription: 'You can bookmark or share the URL below to quickly access this report.',
               type: SAVED_VIEW_TYPE.SHARE_URL,
               show: true,
          },
     ];

     const checkIsDelete = () => {
          if (activeAccount.isOwner) {
               return true;
          }

          const isDifferentUser = viewReport.userId !== user.id;
          return !isDifferentUser;
     };

     return (
          <div key={index} className="row-rule d-flex justify-content-between">
               <div className="info-wrap d-flex justify-content-between align-items-center py-2">
                    <div className="info-title">
                         <h4>{viewReport.name}</h4>

                         <div className="d-inline-flex">
                              {viewReport.description && (
                                   <div className="tooltip-wrapper">
                                        <HoverInfoIconTooltip>
                                             <p>{viewReport.description}</p>
                                        </HoverInfoIconTooltip>
                                   </div>
                              )}
                         </div>
                    </div>
               </div>

               <div className="options-wrapper d-flex">
                    {checkIsDelete() && (
                         <div className="option-item hover-show-tooltip">
                              <CLink className="option option-item-delete" onClick={() => handleConfirm(itemDropdown[0], viewReport)}>
                                   <CIcon icon="iconDeleteField" className="icon-delete pointer" />
                              </CLink>

                              <div className="block-tooltip">
                                   <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />

                                   <div className="block-tooltip-text">
                                        <p>Delete Report</p>
                                   </div>
                              </div>
                         </div>
                    )}

                    {intelligenceSetting.aiInsightsEnabled && (
                         <div className="option-item hover-show-tooltip save-report-bell notification-bell mr-0">
                              <CLink className="option option-item-delete" onClick={() => handleAiTemplate(viewReport)}>
                                   <CIcon icon={cilLightbulb} />
                                   {viewReport.totalAiInsights > 0 && (
                                        <CBadge shape="pill" color="danger" className={viewReport.totalAiInsights > 99 ? 'big-number' : ''}>
                                             {viewReport.totalAiInsights}
                                        </CBadge>
                                   )}
                              </CLink>

                              <div className="block-tooltip">
                                   <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />

                                   <div className="block-tooltip-text">
                                        <p>AI Insights</p>
                                   </div>
                              </div>
                         </div>
                    )}

                    <div className="option-item hover-show-tooltip">
                         <CLink className="option option-item-delete" href={viewReport.shareLink} target="_blank">
                              <CIcon icon="icon-eye" />
                         </CLink>

                         <div className="block-tooltip">
                              <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />

                              <div className="block-tooltip-text">
                                   <p>View Report</p>
                              </div>
                         </div>
                    </div>

                    <div className="option-item hover-show-tooltip save-report-bell notification-bell mr-0">
                         <CLink className="option option-item-delete" onClick={() => handleSchedule(viewReport)}>
                              <CIcon icon="cilEnvelopeClosed" />
                              {viewReport.totalSchedule > 0 && (
                                   <CBadge shape="pill" color="danger" className={viewReport.totalSchedule > 99 ? 'big-number' : ''}>
                                        {viewReport.totalSchedule}
                                   </CBadge>
                              )}
                         </CLink>
                         <div className="block-tooltip">
                              <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />
                              <div className="block-tooltip-text">
                                   <p>Delivery Schedule</p>
                              </div>
                         </div>
                    </div>

                    <div className="option-item hover-show-tooltip">
                         <Dropdown>
                              <DropdownToggle caret={false} tag="div" className="d-flex h-100">
                                   <CLink className="option option-item-delete">
                                        <CIcon icon="iconEllipsisVerticalCustom" height={18} />
                                   </CLink>

                                   <div className="block-tooltip">
                                        <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />

                                        <div className="block-tooltip-text">
                                             <p>Action</p>
                                        </div>
                                   </div>
                              </DropdownToggle>

                              <DropdownMenu placement="right-start">
                                   {itemDropdown
                                        .filter((_item) => _item.show)
                                        .filter((_item) => {
                                             if (activeAccount.isOwner) {
                                                  return true;
                                             }
                                             const isTypeFiltered = [SAVED_VIEW_TYPE.SETTING].includes(_item.type);

                                             const isDifferentUser = viewReport.userId !== user.id;
                                             return !(isTypeFiltered && isDifferentUser);
                                        })
                                        .map((_item, key) => (
                                             <DropdownItem key={key} className="d-block" onClick={() => handleConfirm(_item, viewReport)}>
                                                  <div className="d-flex align-items-center mr-5" style={{ gap: '8px' }}>
                                                       <span>{_item.title}</span>
                                                  </div>
                                             </DropdownItem>
                                        ))}
                              </DropdownMenu>
                         </Dropdown>
                    </div>
               </div>
          </div>
     );
};


ViewReportCard.propTypes = {
     handleConfirm: PropTypes.func,
     index: PropTypes.number,
     viewReport: PropTypes.object,
};

export default ViewReportCard;
